import { defineStyleConfig } from '@chakra-ui/react';

export const Button = defineStyleConfig({
  baseStyle: {},
  sizes: {},
  variants: {},
  defaultProps: {},
});
